import { axiosInstance } from '../Middleware'
import { DemandeHsHistoriqueReponse, DemandeHsSaisiePayload, DemandeHsSaisieReponse } from './types'

export class DemandeHsApi {
  // POST /demandeshs/saisie — contrôles + enregistrement d'une saisie d'heures supplémentaires
  // (reprise de bValide()/vEnregistreSaisieHS() de PAGE_HSAGENT). La route générique CRUD
  // POST /demandeshs reste par ailleurs inchangée.
  public static saisie = (payload: DemandeHsSaisiePayload) =>
    axiosInstance.post<DemandeHsSaisieReponse>('/personnel/personnel/demandeshs/saisie', payload)

  // GET /demandeshs/historique — historique fusionné demandes + compteur pour une année donnée
  // (reprise de vHistoHS()/tstHistoHSParAnnee() de PAGE_HSAGENT)
  public static historique = (identifiantAgent: number, annee: number) =>
    axiosInstance.get<DemandeHsHistoriqueReponse>('/personnel/personnel/demandeshs/historique', {
      params: { identifiantAgent, annee },
    })
}
